import type {
  OnFontChanged,
  FontPickerOptions,
  FontPickerOnStyleChange,
  ColorPickerSDKOptions,
} from '@wix/editor-platform-host-integration-apis';

import { HostAPIStudio } from './HostAPIStudio';
import type { HostAPIStudio as HostAPIStudioType } from './HostAPIStudio';
import type { AppData as DMAppData } from '@wix/document-services-types';
import {
  toColorValue,
  toCssVariable,
  mapFontPickerOptions,
  builderFontStyleToFontStyle,
} from '../utils/brand';

const emptyAppData = {} as DMAppData;
const token = '';

export class HostAPIEditor3 extends HostAPIStudio {
  editor: HostAPIStudioType['editor'] = {
    ...this.editor,
    openColorPicker: async (
      options: ColorPickerSDKOptions,
      onColorChange: (value: {
        color: string;
        theme: string;
        isHover: boolean;
      }) => void,
    ) => {
      await this.platformApiMethods.editor.selectColor?.({
        showBrand: true,
        showCustom: true,
        initialValue: toCssVariable(options.color || ''),
        biData: { origin: 'editor_platform_sdk' },
        onChange: (color: string) => {
          return onColorChange({
            color: toColorValue(this.documentServicesAPI, color),
            theme: '',
            isHover: false,
          });
        },
      });
    },
    openFontPicker: async (
      options: FontPickerOptions,
      onStyleChange: FontPickerOnStyleChange,
      onFontChangedV2?: OnFontChanged,
    ) => {
      await this.platformApiMethods.editor.openBuilderFontPicker?.(
        emptyAppData,
        token,
        mapFontPickerOptions(options),
        onStyleChange,
        (fontStyle, fieldAccessibility) => {
          onFontChangedV2?.(
            builderFontStyleToFontStyle(fontStyle),
            fieldAccessibility,
          );
        },
      );
    },
  };
}
